import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store/combineReducer";
import InfoOffcanvas from '../../components/others/InfoOffCanvas/InfoOffCanvas';
import "../Results/results_page.scss";
import AsesorTurnos from "./turnos";
// import AsesorAusentismos from "./ausentismos";
// import ServiciosPrestaciones from "./servicios-prestaciones";
import CompanySelectorAsesor from "../../components/others/CompanySelectorAsesor";

const PAGE_TABS = [
  { id: "turnos", label: "Servicios - Prestaciones", icon: "📋" },
  // { id: "servicios-prestaciones", label: "Servicios - Prestaciones", icon: "📋" },
  // { id: "turnos", label: "Turnos", icon: "📅" },
  // { id: "ausentismos", label: "Ausentismos", icon: "🏥" },
];

const AsesorResultsPage = () => {
  const { companies, currentCompany } = useSelector((state: RootState) => state.user);
  const [currentTab, setCurrentTab] = useState(PAGE_TABS[0].id);
  const [selectedCompanyId, setSelectedCompanyId] = useState<string>(
    currentCompany?.id || (companies && companies[0]?.id) || ""
  );

  // Actualizar compañía seleccionada cuando cambie en Redux
  useEffect(() => {
    if (currentCompany?.id) {
      setSelectedCompanyId(currentCompany.id);
    }
  }, [currentCompany]);

  const handleChangeTab = (tab: string) => {
    setCurrentTab(tab);
  };

  const getCurrentTabInfo = () => {
    return PAGE_TABS.find(tab => tab.id === currentTab) || PAGE_TABS[0];
  };

  const renderTabContent = () => {
    switch (currentTab) {
      case "turnos":
        return <AsesorTurnos companyId={selectedCompanyId} />;
      // case "servicios-prestaciones":
      //   return <ServiciosPrestaciones companyId={selectedCompanyId} />;
      // case "ausentismos":
      //   return <AsesorAusentismos companyId={selectedCompanyId} />;
      default:
        return <AsesorTurnos companyId={selectedCompanyId} />;
    }
  };

  return (
    <div className="main-container">
      <div className="atendoo-card">
        {/* Header Section */}
        <div className="custom-header">
          <div className="header-top">
            <h6 className="subtitle">Resultados de Compañías</h6>
            <InfoOffcanvas title="INFORMACIÓN PARA ASESORES">
              <div className="results-info">
                <div className="info-section">
                  <h4 className="info-title">Acceso a Resultados</h4>
                  <ul className="info-list">
                    <li>Selecciona una compañía para ver sus resultados</li>
                    <li>Visualiza turnos y ausentismos completados</li>
                    <li>Descarga reportes en formato Excel</li>
                    <li>Filtra resultados por fechas específicas</li>
                    <li>Descarga PDFs de informes médicos</li>
                  </ul>
                </div>

                <div className="info-section">
                  <h4 className="info-title">Servicios - Prestaciones</h4>
                  <ul className="info-list">
                    <li>Vista unificada de todos los servicios y prestaciones médicas</li>
                    <li>Incluye turnos y ausentismos en una sola tabla</li>
                    <li>Visualiza fechas de solicitud, turno y admisión / visita</li>
                    <li>Descarga informes médicos, certificados y partes médicos</li>
                    <li>Filtra por DNI, apellido o rango de fechas</li>
                    <li>Descarga Excel con toda la información unificada</li>
                    <li>Vista completa de la actividad médica de la compañía</li>
                  </ul>
                </div>

                {/* <div className="info-section">
                  <h4 className="info-title">Turnos</h4>
                  <ul className="info-list">
                    <li>Consulta todos los turnos finalizados de la compañía</li>
                    <li>Visualiza fechas de solicitud, turno y admisión</li>
                    <li>Descarga informes médicos y certificados</li>
                    <li>Filtra por DNI, apellido o rango de fechas</li>
                  </ul>
                </div>

                <div className="info-section">
                  <h4 className="info-title">Ausentismos</h4>
                  <ul className="info-list">
                    <li>Revisa controles de ausentismo realizados</li>
                    <li>Visualiza diagnósticos y fechas de alta</li>
                    <li>Descarga partes médicos en PDF</li>
                    <li>Consulta el tipo de control realizado (Domicilio, Videollamada, etc.)</li>
                  </ul>
                </div> */}

                <div className="info-section">
                  <h4 className="info-title">Selección de Compañía</h4>
                  <ul className="info-list">
                    <li>Al cambiar de compañía, se actualizará el código cliente en la barra superior</li>
                    <li>Los resultados mostrados corresponden únicamente a la compañía seleccionada</li>
                    <li>Puedes tener múltiples compañías asociadas a tu perfil</li>
                  </ul>
                </div>
              </div>
            </InfoOffcanvas>
          </div>
        </div>

        {/* Company Selector */}
        <CompanySelectorAsesor />

        {/* Navigation Tabs */}
        <div className="tabs-container mb-3">
          <nav className="tabs-nav">
            {PAGE_TABS.map((tab) => {
              return (
                <button
                  key={tab.id}
                  className={`tab-button ${currentTab === tab.id ? 'active' : ''}`}
                  onClick={() => handleChangeTab(tab.id)}
                >
                  <span className="tab-icon">{tab.icon}</span>
                  <span className="tab-label">{tab.label}</span>
                </button>
              )
            })}
          </nav>
        </div>

        <div className="current-tab-info">
          <div className="tab-indicator">
            <h5 className="section-title">{getCurrentTabInfo().label}</h5>
          </div>
        </div>

        {/* Tab Content */}
        {renderTabContent()}
      </div>
    </div>
  );
};

export default AsesorResultsPage;

